import * as React from "react";

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.418 1.712a.637.637 0 011.164 0l1.557 3.3c.095.2.278.34.49.372l3.48.53c.534.08.746.765.36 1.158l-2.518 2.57a.7.7 0 00-.187.6l.594 3.628c.091.556-.465.979-.942.717l-3.114-1.713a.625.625 0 00-.604 0l-3.114 1.713c-.477.262-1.034-.161-.943-.716l.595-3.628a.7.7 0 00-.187-.602L1.53 7.072c-.385-.393-.173-1.078.36-1.159l3.482-.529a.652.652 0 00.489-.372l1.557-3.3z"
        fill={props.fill || "#F1563F"}
      />
    </svg>
  );
}

export default SvgComponent;
